import React, { useEffect, useRef, useState } from 'react';
import {personColors, MAX_SPEAKERS } from './conf'
import { CombinedState } from 'reducers';
import { secondsToFrame } from 'utils/media-time';
interface Props {
    appliedStyle: any,
    segment: {
        start: number,
        end: number,
        text: string,
        speaker: string,
    },
    index: number,
    changeFrame: (frame: number) => void,
    frameRate: number,
    stopFrame: number,
    scrollFn: (target: HTMLDivElement) => void;
    onChangeTranscript: (index: number, segment: any) => void,
    isCurrent: boolean,
    playing: boolean,
    onSwitchPlay: (play: boolean) => void
    speakerCount: number,
    isSelected: boolean,
    isLastSelected: boolean,
    clearSelected: () => void;
    changeSpeakerBulk: (speaker: string) => void
    phase: string;
    images: any | null;
    audios: any | null;
    playAudio: (play: boolean, frame: number) => void

    editingIdx: number;
    setEditingIdx: (idx: number) => void;
    onSelectSegment: (idx: number) => void;
    startFrame: number;

}

interface DispatchToProps {
    setEditedContent: (text: string) => void;
}

function mapDispatchToProps(dispatch: any): DispatchToProps {
    return {
        setEditedContent(text: string) {
            dispatch(softUpdateTranscriptCurrentSegment({
                text
            }));
        }
    }
}

import {Row, Col, Avatar, Dropdown, Menu} from 'antd'
import {CustomerServiceFilled, DeleteOutlined, PlusOutlined, SoundOutlined, UserOutlined} from '@ant-design/icons'
import './style.scss';
import TransciptUtteranceEditor from './transcript-utterance-editor';
import { connect } from 'react-redux';
import { softUpdateTranscriptCurrentSegment } from 'actions/annotation-actions';
function TransciptUtteranceText(props: Props & DispatchToProps) {
    const {
        appliedStyle, isCurrent, playing, onSwitchPlay, changeFrame, segment, frameRate, stopFrame,
    onChangeTranscript, index, speakerCount, isSelected, clearSelected, changeSpeakerBulk,
    phase, images, audios, playAudio, scrollFn,
    editingIdx, setEditingIdx, setEditedContent, onSelectSegment, startFrame

} = props;

    const utteranceRef = useRef<HTMLDivElement>(null);


    useEffect(() => {
        if (isCurrent && utteranceRef.current) {
            scrollFn(utteranceRef.current);
        }
    }, [isCurrent]);

    useEffect(() => {
        if (editingIdx === index && utteranceRef.current) {
            utteranceRef.current.focus();
        }
    }, [editingIdx, index]);

    const speakerColorId = segment.speaker && parseInt(segment.speaker.split('_')[1]);
    const speakerServerId = segment.speaker && segment.speaker.split('_')[2] && parseInt(segment.speaker.split('_')[2]);

    return (
        <>
            <div
                ref={utteranceRef}
                style={{
                    marginTop: 10,
                    cursor: 'pointer',
                    ...appliedStyle,
                    backgroundColor: isSelected ? 'rgb(19, 72, 123)' : 'rgb(0, 21, 41)'
                }}
                onClick={() => {
                    clearSelected();
                    onSelectSegment(index);
                    if (playing) {
                        onSwitchPlay(false);
                    }

                    if (editingIdx === -1)
                        changeFrame(secondsToFrame(segment.start, startFrame, stopFrame, frameRate));
                }}
            >
                <div>
                    {segment.speaker && (
                        <Dropdown
                            overlayClassName='speakerChangeDropDown'
                            onVisibleChange={() => {
                                onSwitchPlay(false);
                            }}
                            overlayStyle={{animationDuration: '0s'}}
                            overlay={<Menu mode="horizontal" style={{
                            backgroundColor: 'rgba(0, 22, 40, 0.5)',
                            backdropFilter: 'blur(5px)'
                        }}>
                            {phase === 'phase0' && <>
                            {Array(speakerCount).fill(0).map((_, idx) => (
                                <Menu.Item onClick={()=>{
                                    if (!isSelected) {
                                        onChangeTranscript(index, {
                                            ...segment,
                                            speaker: "SPEAKER_"+(idx)
                                        })
                                    } else {
                                        changeSpeakerBulk("SPEAKER_"+(idx));
                                    }
                                }}>
                                    <div style={{ height: 36}} >
                                    <Avatar
                                    size={32}
                                    icon={<UserOutlined />}
                                    style={{
                                        backgroundColor: personColors[idx],
                                    }}
                                     />
                                    </div>
                                </Menu.Item>
                            ))}
                            <Menu.Item onClick={()=>{
                                    if (!isSelected) {
                                        onChangeTranscript(index, {
                                            ...segment,
                                            speaker: "RADIO_00",
                                        })
                                    } else {
                                        changeSpeakerBulk("RADIO_00");
                                    }
                                }}>
                                    <div style={{ height: 36}} >
                                    <Avatar
                                    size={32}
                                    icon={<CustomerServiceFilled />}
                                    style={{
                                        backgroundColor: personColors[0],
                                    }}
                                     />
                                    </div>
                                </Menu.Item>
                            {speakerCount < MAX_SPEAKERS &&
                            <Menu.Item onClick={()=>{
                                    if (!isSelected) {
                                        onChangeTranscript(index, {
                                            ...segment,
                                            speaker: "SPEAKER_"+(speakerCount)
                                        })
                                    } else {
                                        changeSpeakerBulk("SPEAKER_"+(speakerCount));
                                    }
                                }}>
                                    <div style={{ height: 36}} >
                                    <Avatar
                                    size={32}
                                    icon={<PlusOutlined />}
                                    style={{
                                        backgroundColor: 'grey',
                                    }}
                                     />
                                    </div>
                                </Menu.Item>
                            }
                            </>}
                            {phase === 'phase1a' &&  images &&
                                Array(Object.keys(images).length).fill(0).map((_, idx) => (
                                    <Menu.Item onClick={()=>{
                                        onChangeTranscript(index, {
                                            ...segment,
                                            speaker: "SPEAKER_"+speakerColorId+'_'+(Object.keys(images)[idx]  + '_IMG')
                                        })
                                    }}>
                                        <div style={{ height: 66}} >
                                        <Avatar
                                        size={64}

                                        style={{
                                            border: `2px solid ${personColors[speakerColorId as number]}`,
                                            backgroundImage: `url(${images[Object.keys(images)[idx]]})`,
                                            backgroundSize: 'contain',
                                        }}
                                        />
                                        </div>
                                    </Menu.Item>
                                ))
                            }
                            {phase === 'phase1a' &&  audios &&
                                Array(Object.keys(audios).length).fill(0).map((_, idx) => (
                                    <Menu.Item onClick={()=>{
                                        onChangeTranscript(index, {
                                            ...segment,
                                            speaker: "SPEAKER_"+speakerColorId+'_'+(Object.keys(audios)[idx] + '_AUDIO')
                                        })
                                    }}>
                                        <div style={{ height: 66}}
                                            onMouseEnter={() => {
                                                playAudio(true, audios[Object.keys(audios)[idx]])
                                            }}

                                            onMouseLeave={() => {
                                                playAudio(false, 0);
                                            }}
                                        >
                                        <Avatar
                                        size={64}
                                        icon={<SoundOutlined />}
                                        style={{
                                            backgroundColor: personColors[speakerColorId as number],
                                        }}
                                        />
                                        </div>
                                    </Menu.Item>
                                ))
                            }
                        </Menu>} trigger={['contextMenu']}>
                        <Avatar
                            size={['phase2a', 'phase3a'].includes(phase) ? 45 : 32}
                            icon={
                                segment.speaker.split('_')[0] === 'RADIO' ?
                                    <CustomerServiceFilled /> :
                                (
                                    ['phase1a', 'phase1b', 'phase2a', 'phase2b', 'phase3a', 'phase3b'].includes(phase) ?  (
                                        // phase1a and phase1b

                                        segment.speaker.split('_')[3] === 'AUDIO' ? // is mapped to audio tag?
                                            (
                                                audios && audios[speakerServerId] != null ? <SoundOutlined/> : <UserOutlined/>
                                            ):
                                        (images && images[speakerServerId] != null ? <></> : <UserOutlined />)
                                    ) : (
                                        // phase0 and phase2
                                        <UserOutlined/>
                                    )
                                )


                            }
                            style={{
                                backgroundColor: personColors[speakerColorId as number],
                                backgroundImage: speakerServerId && images && images[speakerServerId] ? `url(${images[speakerServerId]})` :undefined,
                                backgroundSize: 'contain',
                                border: speakerServerId ? `2px solid ${personColors[speakerColorId as number]}` : undefined,
                            }}

                        />
                      </Dropdown>

                    )}
                </div>
                <Row>
                    <Col span={2}>

                        {isCurrent && phase === 'phase0' && (
                            <DeleteOutlined
                                style={{ fontSize: 12 }}
                                onClick={() => {
                                    onChangeTranscript(index, null);
                                }}
                            />
                        )}
                    </Col>
                    <Col span={21}>
                        <div onDoubleClick={() => {
                            if (isCurrent && phase === 'phase0') {
                                setEditingIdx(index);
                            }
                        }} style={['phase2a', 'phase3a'].includes(phase) ? {fontSize: '17px'} : {}}>
                            {editingIdx === index &&
                            <Row>
                                <Col sm={24} style={{backgroundColor: '#859aae'}}>
                                    <TransciptUtteranceEditor setEditedContent={setEditedContent} segment={segment}/>
                                </Col>
                            </Row>
                            }
                            {editingIdx !== index && segment.text}
                        </div>
                    </Col>
                    <Col span={1}></Col>
                </Row>
            </div>
        </>
    );
}


export default connect(null, mapDispatchToProps)(React.memo(TransciptUtteranceText));
